import { render, staticRenderFns } from "./RideCard.vue?vue&type=template&id=796f0454&"
import script from "./RideCard.vue?vue&type=script&lang=js&"
export * from "./RideCard.vue?vue&type=script&lang=js&"
import style0 from "./RideCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports